import _login from './login/login.config';
import _sia from './sia/sia.config';
import _requests from './requests/requests.config';
import _settings from './settings/settings.config';
import {PATS_NAMES_ROUTES} from './aiFactoryRoutes/aiFactoryRoutes.config';
import _classification, {CLASS_REDUCER} from './classification/classification.consts';
import _FILES from './Files/files';
import _INPUT_RULES from './inputRules/inputsRules.config';
import {_VI_FEATURE} from './VIFeatures/VIFeatures.config';
import {_SYSTEM_TITLES, InsightsType} from './SystemTitles/SystemTitles.config';
import _SYSTEM_PROPERTIES from './systemProperties/systemProperties';
export enum Tag{
    DEFAULT= 'taggingMode',
    LISTEN= 'listenMode',
    SEGMENTHOR= 'segmenthor',
    ACCURACY= 'accuracyMode',
    CLASSIFICATION='classification',
    DEBUG='analyzeDebug',
    CONFIGURATION= 'configuration'
}

export {
    _login,
    _sia,
    _requests,
    _settings,
    _INPUT_RULES,
    _SYSTEM_TITLES,
    _SYSTEM_PROPERTIES,
    InsightsType,
    _FILES,
    PATS_NAMES_ROUTES,
    _VI_FEATURE,
    _classification,
    CLASS_REDUCER
};
